import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Injectable()
export class AlertPopupService {

  constructor(
    private router: Router
  ){

  }

  errorAlert(message: string) {
    Swal.fire({
      type: 'error',
      title: 'Foul!',
      text: message,
    });
  }

  errorAlertWithResult(message: string, buttonName, routeName) {
    Swal.fire({
      title: 'Error',
      text: message,
      type: 'warning',
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: buttonName
    }).then((result) => {
      if (result.value) {
        if (routeName !== '') {
          this.router.navigate([routeName]);
        } else {
          window.history.back();
        }

      }
    });
  }

  toasterErrorAleart(message: string) {
    Swal.fire({
      position: 'top-end',
      title: message,
      showConfirmButton: false,
      timer: 2500,
      backdrop: false,
      customClass: {
        popup: 'new-popup-class',
        header: 'new-header-class',
        title: 'new-title-class',
      }
    });
  }

  errorAlertSuccess(message: string) {
    Swal.fire({
      type: 'success',
      title: message,
      showConfirmButton: false,
      timer: 4000,
      backdrop: false,
      customClass: {
        header: 'new-header-class',
      }
    });
  }

  alertSuccessNoDismiss(message: string) {
    Swal.fire({
      type: 'success',
      title: message,
      showConfirmButton: true,
      backdrop: true,
      customClass: {
        header: 'new-header-class',
      }
    });
  }

  purchaseSuccess(message: string) {
    Swal.fire({
      title: 'Success!',
      text: message,
      type: 'success',
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Done'
    }).then((result) => {
      if (result.value) {
        this.router.navigateByUrl('/groups');
      }
    });
  }

  reservationSuccess(message: string) {
    Swal.fire({
      title: 'Reservation Success!',
      text: message,
      type: 'success',
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Done'
    }).then((result) => {
      if (result.value) {
        this.router.navigateByUrl('/');
      }
    });
  }

  errorAlertError(message: string) {
    Swal.fire({
      type: 'warning',
      title: message,
      showConfirmButton: false,
      timer: 4000,
      backdrop: false,
      customClass: {
        header: 'new-header-class',
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/SS-Alert/alert-popup.service.ts